<script setup lang="ts">
/**
 * Smile button of a reply box (owner 27 ก.ย. 69 "เพิ่มสามารถเพิ่ม emoji ที่กล่องแชท"). Opening it by mouse leaves the
 * focus in the typing box (the caret stays where it was); by keyboard the picker's search box takes the focus.
 * The picker and its emoji data are separate chunks, loaded the first time it opens.
 */
import { defineAsyncComponent, ref } from 'vue'
import Icon from '../ui/Icon.vue'

const EmojiPicker = defineAsyncComponent(() => import('./EmojiPicker.vue'))

const props = defineProps<{ target: HTMLTextAreaElement | null }>()
const open = ref(false)
const byKeyboard = ref(false)
const btn = ref<HTMLButtonElement | null>(null)

function toggle(e: MouseEvent): void {
  byKeyboard.value = e.detail === 0 // Enter / Space on the button
  open.value = !open.value
}

function close(refocus: boolean): void {
  open.value = false
  if (refocus) props.target?.focus({ preventScroll: true })
}
</script>

<template>
  <button
    ref="btn"
    type="button"
    class="emo-b"
    :class="{ on: open }"
    aria-label="ใส่อีโมจิ"
    title="อีโมจิ"
    aria-haspopup="dialog"
    :aria-expanded="open"
    @mousedown.prevent
    @click="toggle"
  >
    <Icon name="smile" />
  </button>
  <EmojiPicker v-if="open" :target="target" :button="btn" :focus-search="byKeyboard" @close="close" />
</template>

<style scoped>
.emo-b {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  border-radius: 8px;
  color: var(--mut);
}
.emo-b:hover,
.emo-b.on {
  background: #eef2f0;
  color: var(--ink);
}
</style>
